import { useState } from "react";

type ApiKeyPanelProps = {
  hasApiKey: boolean;
  isRunning: boolean;
  onSetKey: (key: string) => void;
  onClearKey: () => void;
};

export function ApiKeyPanel({
  hasApiKey,
  isRunning,
  onSetKey,
  onClearKey,
}: ApiKeyPanelProps) {
  const [draft, setDraft] = useState("");

  const canSubmit = draft.trim().startsWith("sk-ant-");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!canSubmit) return;
    onSetKey(draft.trim());
    setDraft("");
  };

  return (
    <div className="nes-panel p-4 pt-5">
      <span className="nes-panel-header">BRING YOUR OWN KEY</span>
      {hasApiKey ? (
        <div className="flex flex-col gap-3">
          <p className="font-pixel text-[10px] text-nes-green">
            ● KEY ACTIVE — SESSION ONLY
          </p>
          <p className="text-[11px] font-mono text-nes-gray">
            Never stored server-side. Closing the tab forgets it. Revoke it at
            console.anthropic.com when you're done.
          </p>
          <button
            className="nes-btn nes-btn-red"
            onClick={onClearKey}
            disabled={isRunning}
          >
            FORGET KEY
          </button>
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          <p className="text-[11px] font-mono text-nes-white leading-relaxed">
            Claude plays with YOUR Anthropic API key. It lives in this browser
            session only — never stored, never logged, gone when you leave.
          </p>
          <ol className="text-[11px] font-mono text-nes-gray leading-relaxed list-decimal list-inside">
            <li>
              Grab a key at{" "}
              <a
                href="https://console.anthropic.com/settings/keys"
                target="_blank"
                rel="noreferrer"
                className="text-nes-blue underline"
              >
                console.anthropic.com
              </a>
            </li>
            <li>Set a low spend limit — $5 is plenty</li>
            <li>Paste it below and hit START</li>
            <li>
              Revoke the key when you're done. Seriously — takes 10 seconds,
              future-you says thanks.
            </li>
          </ol>
          <p className="text-[11px] font-mono text-nes-gold">
            A run through 1-1 usually costs $0.50–$3 in tokens.
          </p>
          <form onSubmit={handleSubmit} className="flex gap-2">
            <input
              type="password"
              autoComplete="off"
              spellCheck={false}
              placeholder="sk-ant-api03-..."
              value={draft}
              onChange={(e) => setDraft(e.target.value)}
              className="flex-1 min-w-0 border-2 border-nes-border bg-black text-nes-white font-mono text-xs px-2 py-2 outline-none focus:border-nes-gold"
            />
            <button
              type="submit"
              className="nes-btn nes-btn-green"
              disabled={!canSubmit}
            >
              USE KEY
            </button>
          </form>
        </div>
      )}
    </div>
  );
}
